import Vue from 'vue'
import VueRouter from 'vue-router'

import firebase from 'firebase/app'
import 'firebase/app'
import 'firebase/auth'

import Home from '../views/Home.vue'
import Plants from '../views/Plants.vue'
import Plant from '../views/Plant.vue'
import Surveys from '../views/Surveys.vue'
import Survey from '../views/Survey.vue'
import SignIn from '../views/SignIn.vue'
import SignInReset from '../views/SignInReset.vue'
import Users from '../views/Users.vue'
import UserAdd from '../views/UserAdd.vue'
import User from '../views/User.vue'
import Report from '../views/Report.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '*',
        redirect: '/'
    },
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/plants',
        name: 'Plants',
        component: Plants
    },
    {
        path: '/plant',
        name: 'PlantAdd',
        component: Plant
    },
    {
        path: '/plant/:plantId',
        name: 'Plant',
        component: Plant
    },
    {
        path: '/surveys',
        name: 'Surveys',
        component: Surveys
    },
    {
        path: '/survey/:parentId?',
        name: 'SurveyAdd',
        component: Survey
    },
    {
        path: '/survey/:surveyId',
        name: 'Survey',
        component: Survey
    },
    {
        path: '/users',
        name: 'Users',
        component: Users,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/user',
        name: 'UserAdd',
        component: UserAdd,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/user/:userId',
        name: 'User',
        component: User,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/report',
        name: 'Report',
        component: Report,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/imprint',
        name: 'Imprint',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/Imprint.vue')
    },
    {
        path: '/signin',
        name: 'SignIn',
        component: SignIn
    },
    {
        path: '/signinreset',
        name: 'SignInReset',
        component: SignInReset
    }
]

const router = new VueRouter({
    routes
})

// Protect routes
router.beforeEach((to, from, next) => {
    const currentUser = firebase.auth().currentUser;
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

    if (!currentUser && requiresAuth) {
        // User not signed in but route requires auth -> redirect
        next({name: 'SignIn'})
    } else {
        next()
    }
})

export default router
